import React from 'react'
import './Widgets.css';
import InfoIcon from '@mui/icons-material/Info';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

function Widgets() {
    const newsArticle = (title, subtitle) => (
        <div className='widgets_header'>
            <div className='widgets_header_left'>
                <FiberManualRecordIcon/>
            </div>
            <div className='widgets_header_right'>
                <h4>{title}</h4>
                <p>{subtitle}</p>
            </div>
        </div>
    );

  return (
    <div className='widgets'>
        <div className='widgets_header'>
            <h2>Linkedin News</h2>
            <InfoIcon />
        </div>
        {newsArticle("Elon Musk to Fight Zuck", "Top news - 9999 readers")}
        {newsArticle("Zuck launches Thread", "Tech - 69 readers")}
        {newsArticle("Why AI kinds sucks", "AI news - 69000 readers")}
        {newsArticle("Barbie vs Oppenheimer", "Movie - 712 readers")}
        {newsArticle("Sell your Kidney to get Apples Vision Pro", "Tech - 8290 readers")}
        {newsArticle("Elon vs Musk, cage Battle!!", "Business - 10020 readers")}
    </div>
  )
}

export default Widgets